import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Menu, X, Zap, Share2 } from "lucide-react";
import { shareLink } from "./MyLinkCard";
import { useContent } from "../lib/content";

const links = [
  { to: "/", id: "eventi", key: "nav_events" },
  { to: "/tavoli", id: "tavoli", key: "nav_tables" },
  { to: "/carpooling", id: "carpool", key: "nav_carpool" },
  { to: "/affiliazione", id: "affiliazione", key: "nav_affiliation" },
  { to: "/gallery", id: "gallery", key: "nav_gallery" },
  { to: "/contatti", id: "contatti", key: "nav_contacts" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const { c } = useContent();
  const [open, setOpen] = React.useState(false);
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-50 bg-black/80 backdrop-blur-xl border-b border-neutral-800">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <Zap className="w-6 h-6 text-neon group-hover:text-glow-neon transition" strokeWidth={2.5} />
          <span className="font-display text-xl text-white tracking-tighter">{c.brand_part1}<span className="text-neon">{c.brand_part2}</span></span>
        </Link>
        <nav className="hidden lg:flex items-center gap-6 font-mono text-[11px] tracking-[0.2em]">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.id}`}
              className={({isActive}) => `transition hover:text-neon ${isActive ? "text-neon" : "text-neutral-400"}`}>
              {c[l.key]}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <button onClick={()=>shareLink("copy", user.referral_code)} className="flex items-center gap-1 font-mono text-[11px] tracking-[0.2em] text-neon hover:text-glow-neon" data-testid="nav-share-link">
                <Share2 className="w-3 h-3"/> IL MIO LINK
              </button>
              {user.role === "affiliate" && (
                <Link to="/incassi" className="font-mono text-[11px] tracking-[0.2em] text-neutral-300 hover:text-neon" data-testid="nav-earnings">INCASSI</Link>
              )}
              {user.role === "admin" && (
                <Link to="/admin" className="font-mono text-[11px] tracking-[0.2em] text-alert hover:text-glow-alert" data-testid="nav-admin">ADMIN</Link>
              )}
              <span className="font-mono text-[11px] text-neutral-500 tracking-widest">{user.name.toUpperCase()}</span>
              <button onClick={async()=>{await logout(); nav("/");}} className="btn-ghost !py-2 !px-3 text-[11px]" data-testid="nav-logout">USCITA</button>
            </>
          ) : (
            <>
              <Link to="/login" className="font-mono text-[11px] tracking-[0.2em] text-neutral-300 hover:text-neon" data-testid="nav-login">LOGIN</Link>
              <Link to="/register" className="btn-primary !py-2 !px-3 text-[11px]" data-testid="nav-register">ENTRA</Link>
            </>
          )}
        </div>
        <button className="lg:hidden text-white" onClick={()=>setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X/> : <Menu/>}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-neutral-800 bg-black">
          <div className="flex flex-col py-4 px-6 gap-4 font-mono text-sm tracking-widest">
            {links.map(l=>(
              <NavLink key={l.to} to={l.to} onClick={()=>setOpen(false)}
                className={({isActive})=>`${isActive?"text-neon":"text-neutral-300"}`}
                data-testid={`nav-mobile-${l.id}`}>
                {c[l.key]}
              </NavLink>
            ))}
            {user ? (
              <>
                <button onClick={()=>{shareLink("copy", user.referral_code); setOpen(false);}} className="text-left text-neon" data-testid="nav-mobile-share-link">COPIA IL MIO LINK</button>
                {user.role === "affiliate" && <NavLink to="/incassi" onClick={()=>setOpen(false)} className="text-neutral-300" data-testid="nav-mobile-earnings">INCASSI</NavLink>}
                {user.role === "admin" && <NavLink to="/admin" onClick={()=>setOpen(false)} className="text-alert">ADMIN</NavLink>}
                <button onClick={async()=>{await logout(); setOpen(false); nav("/");}} className="text-left text-neutral-400">USCITA</button>
              </>
            ) : (
              <>
                <NavLink to="/login" onClick={()=>setOpen(false)} className="text-neutral-300">LOGIN</NavLink>
                <NavLink to="/register" onClick={()=>setOpen(false)} className="text-neon">ENTRA</NavLink>
              </>
            )}
          </div>
        </div>
      )}
      <div className="scan-line" />
    </header>
  );
}
